var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTimeFormBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "time_form") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Op\\xE9rations---non-conformit\\xE9s-2",
    transform: "translate(-1126.000000, -1098.000000)",
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.67,1111.34 C1128.99,1111.34 1126,1108.35 1126,1104.67 C1126,1100.99 1128.99,1098 1132.67,1098 C1136.35,1098 1139.34,1100.99 1139.34,1104.67 C1139.34,1108.35 1136.35,1111.34 1132.67,1111.34 Z M1132.67,1110 C1134.08,1110 1135.44,1109.44 1136.44,1108.44 C1137.44,1107.44 1138,1106.09 1138,1104.67 C1138,1103.26 1137.44,1101.9 1136.44,1100.9 C1135.44,1099.9 1134.08,1099.34 1132.67,1099.34 C1131.26,1099.34 1129.9,1099.9 1128.9,1100.9 C1127.9,1101.9 1127.34,1103.26 1127.34,1104.67 C1127.34,1106.09 1127.9,1107.44 1128.9,1108.44 C1129.9,1109.44 1131.26,1110 1132.67,1110 Z M1133.34,1104.67 L1136,1104.67 L1136,1106 L1132,1106 L1132,1101.34 L1133.34,1101.34 L1133.34,1104.67 Z",
    id: "time_form"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeFormBlack);
export default __webpack_public_path__ + "static/media/icon_time_form_black.ffca39582fe6e55308b014f58d2d2ee6.svg";
export { ForwardRef as ReactComponent };